module.exports = __webpack_public_path__ + "img/yuanbanke@2x.eb1d1611.png";